<div class="grid">

    <div class="col-12">

        <p-card subheader="" class="wal-tile">

            <ng-template pTemplate="header">
                <div class="custom-card-header">

                    <!-- Row 1: title + view-mode toggle -->
                    <div class="header-first-row">
                        <div class="header-text">Apple Re-enrollment Events</div>

                        <div class="header-view-toggle">
                            <p-button [disabled]="viewingModel === 'Summary'"
                              label="Summary"
                              styleClass="p-button-success wal-success p-button-raised p-button-rounded"
                              (click)="onSetViewingModel('Summary')">
                            </p-button>

                            <p-button [disabled]="viewingModel === 'Details'"
                              label="Details"
                              styleClass="p-button-success wal-success p-button-raised p-button-rounded"
                              (click)="onSetViewingModel('Details')">
                            </p-button>
                        </div>
                    </div>

                    <!-- Row 2: criteria + totals -->
                    <div class="header-second-row">

                        <div class="criteria-row">
                            <div class="criteria-item">
                                <label for="brandCode">Brand Code:</label>
                                <p-select id ="brandCode" [options]="brandCodes" 
                                    [(ngModel)]="selectedBrandCode" 
                                    [editable]="false" class="margin-left" [style]="{'width':'100%'}">
                                </p-select>
                            </div>
                            <div class="criteria-item">
                                <label for="dateFrom">Date From:</label>
                                <p-datepicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" dataType="string"
                                    [showIcon]="true">
                                </p-datepicker>
                            </div>
                            <div class="criteria-item">
                                <label for="dateTo">Date To:</label>
                                <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd" dataType="string"
                                    [showIcon]="true">
                                </p-datePicker>
                            </div>
                            <div class="criteria-item">
                                <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded"
                                    (click)="onSearchClick($event)">
                                </p-button>
                            </div>
                            <div id="idSpinner" [hidden]="isSpinnerHidden">
                                <div class="loader"></div>
                            </div>
                        </div>

                        @if(viewingModel === 'Summary') {
                            <div class="header-totals">
                                <span class="total-badge">Total Attempts: {{ totalReenrollmentAttemptCnt }}</span>
                                <span class="total-badge">Total Rendered: {{ totalPassRenderedCnt }}</span>
                                <span class="total-badge">Total Registered: {{ totalRegisteredCnt }}</span>
                            </div>
                        }

                    </div>

                </div>
            </ng-template>

            <!--  G R I D  -->

            <!-- Both view blocks stay mounted (toggled via [hidden]) so that the
                 Details virtual-scroll datasource is always alive and a Search
                 click can reload it regardless of which view is currently active. -->
            <div class="ng-template w-full" [hidden]="viewingModel !== 'Summary'">

                    <div class="grid">

                        <div class="col-7">

                            <p-table #dtt [columns]="summaryColumns" [value]="summaryRows" selectionMode="single"
                                class="wal-table"
                                tableStyleClass="prime-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                                sortMode="multiple" [paginator]="true" [rows]="15">
                                <ng-template pTemplate="caption">
                                Apple Re-enrollment Events
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                                </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData">
                                        @for (col of columns; track col.field) {
                                            <td [style.width]="col.width" [style.display]="col.display">
                                                {{ rowData[col.field] }}
                                            </td>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div style="text-align:left">
                                        <p-button type="button" label="CSV Export"
                                            styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dtt.exportCSV()">
                                        </p-button>
                                        <p-button type="button" label="PDF Export"
                                            styleClass="p-button-warning p-button-raised p-button-rounded margin-left" (click)="exportToPdf()">
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-table>

                        </div>

                        <div class="col-4 chart-col">
                            @if(tabValue === 'Summary' && hasData) {

                                @defer (on viewport) {
                                    <p-chart [type]="selectedChartType"
                                        #chart
                                        [data]="chartData"
                                        [options]="chartOptions"
                                        class="wal-chart-container">
                                    </p-chart>
                                } @placeholder {
                                    <div>Loading chart...</div>
                                } @error {
                                    <p>Failed to load the chart.</p>
                                }

                            }
                        </div>
                    </div>

            </div>

            <div class="ng-template w-full" [hidden]="viewingModel !== 'Details'">

                    <div class="p-datatable p-component">

                        <div class="p-datatable-header">
                            <div class="header-row">
                            <div class="wal-page-title">Apple Re-enrollments Details</div>
                            </div>
                        </div>

                        <div class="p-datatable-wrapper">

                            <!-- Column headers with sorting -->
                            <div class="thead row-grid">
                                <div class="th clickable" (click)="toggleSort('eventId')">
                                    Event ID <span>{{ sortField === 'eventId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('brandCode')">
                                    Brand Code <span>{{ sortField === 'brandCode' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('brandName')">
                                    Brand Name <span>{{ sortField === 'brandName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('accountNo')">
                                    Account Number <span>{{ sortField === 'accountNo' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('serialNo')">
                                    Serial Number <span>{{ sortField === 'serialNo' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('appleDeviceId')">
                                    Apple Device ID <span>{{ sortField === 'appleDeviceId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('enrollmentRequestDt')">
                                    Enrollment Request Date <span>{{ sortField === 'enrollmentRequestDt' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('passRenderedDt')">
                                    Pass Rendered Date <span>{{ sortField === 'passRenderedDt' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('passRegisteredDt')">
                                    Pass Registered Date <span>{{ sortField === 'passRegisteredDt' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                            </div>

                            <!-- Scrollable viewport -->
                            <div class="tbody-viewport">
                                @if (datasource) {
                                    <div
                                    class="tr row-grid"
                                    *uiScroll="let row of datasource; let even = even"
                                    (click)="onRowClick(row)"
                                    [class.even]="even"
                                    [class.selected]="isSelected(row)"
                                    >
                                    <div class="td">{{ row.eventId }}</div>
                                    <div class="td">{{ row.brandCode }}</div>
                                    <div class="td">{{ row.brandName }}</div>
                                    <div class="td">{{ row.accountNo }}</div>
                                    <div class="td">{{ row.serialNo }}</div>
                                    <div class="td">{{ row.appleDeviceId }}</div>
                                    <div class="td">{{ row.enrollmentRequestDt }}</div>
                                    <div class="td">{{ row.passRenderedDt }}</div>
                                    <div class="td">{{ row.passRegisteredDt }}</div>
                                    </div>
                                }
                            </div>

                        </div>

                        <div class="p-datatable-footer p-text-secondary">
                        </div>

                    </div>

            </div>

        </p-card>

    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="client-dashboard-warning"></p-confirmDialog>
